import type { FC } from 'react';

import { css, cx } from '@/styled-system/css';

import { calendarDayOfWeekStyles } from './styles/calendar-day-of-week.styles';
import type { CalendarDayOfWeekPropsInterface } from './types/calendar-day-of-week.types';

export const CalendarDayOfWeek: FC<CalendarDayOfWeekPropsInterface> = (props) => {
  const { children, css: cssProp, className, ...rest } = props;

  const styles = css(calendarDayOfWeekStyles, cssProp);

  return (
    <span
      role="columnheader"
      data-c11n-component="Calendar.DayOfWeek"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', styles, className)}
      {...rest}
    >
      {children}
    </span>
  );
};

CalendarDayOfWeek.displayName = 'Calendar.DayOfWeek';
